import { RoleType } from '@csp/dmdp-api-common-dto';
import {
  DEFAULT_SCHEDULE_META_PROPERTY_DATA_PROCESSING,
  DEFAULT_SCHEDULE_META_PROPERTY_ENABLE_RECONSENT,
} from '../mapper/defaultMetaProperties';
import { ConsentConfigOnFeatureV1 } from './ConsentConfigOnFeatureV1';
import { ConsentPlatform } from './ConsentPlatform';

export type ConsentRequestConfigMeta = {
  roles: Array<RoleType>;
  platform: ConsentPlatform | Array<ConsentPlatform>;
  onFeature: Array<ConsentConfigOnFeatureV1>;
  mandatory: boolean;
  dataProcessing?: boolean;
  enableReconsent?: boolean;
};

const emptyMeta = (): ConsentRequestConfigMeta => ({
  roles: [],
  platform: ConsentPlatform.PORTAL,
  onFeature: [],
  mandatory: false,
  dataProcessing: DEFAULT_SCHEDULE_META_PROPERTY_DATA_PROCESSING,
  enableReconsent: DEFAULT_SCHEDULE_META_PROPERTY_ENABLE_RECONSENT,
});

export const ConsentRequestConfigMeta = {
  empty: emptyMeta,
};
